import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import RecordGroupFilterDropdown from "../RecordGroups/RecordGroupFilterDropdown";
import Textarea from "../Textarea-new/Textarea";
import Control from "../Control";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL } from '../../utils';
import { STATUS_1031_BUYER } from '../../investor-status';
import { dateToString } from '../../date-converter';
//thios ui is refrenced by earlier Buyer screen
const InvestorForm = ({theme = 'white', data, paneIndex, isFilter = false, showGroupFilter = false, ownerAgentId, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Investor' : 'Add Investor'}</div>
                {
                    isFilter && showGroupFilter &&
                    <RecordGroupFilterDropdown theme={theme}
                                               groupType='people'
                                               ownerAgentId={ownerAgentId}
                                               value={data.group_id}
                                               valueKey='group_id'
                                               label='People Group'
                                               data={data}
                                               handleParentChange={handleParentDropdownChange}
                    />
                }
                <Input theme={theme}
                       valueType='text'
                       name='first_name'
                       label='First Name'
                       value={data.first_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='last_name'
                       label='Last Name'
                       value={data.last_name}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='phone'
                       name='phone'
                       label='Phone'
                       value={data.phone}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType={isFilter ? 'text' : 'email'}
                       name='email'
                       label='Email'
                       value={data.email}
                       handleParentChange={handleParentChange}
                />
                <Dropdown theme={theme}
                          optionsType='profiles'
                          value={data.profile}
                          valueKey='profile'
                          label='Profile'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                <Dropdown theme={theme}
                          optionsType='investorStatus'
                          value={data.status}
                          valueKey='status'
                          label='Investor Status'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                {
                    !isFilter && data.status === STATUS_1031_BUYER &&
                    <Input theme={theme}
                           type='date'
                           max={dateToString(new Date())}
                           name='date_of_down_leg'
                           label='Date of Down Leg'
                           value={data.date_of_down_leg}
                           required
                           handleParentChange={handleParentChange}
                    />
                }
                {
                    !isFilter &&
                    <div className='last-modified'>Investor status last modified on: {data.last_modified}</div>
                }
                {
                    (data.STATUS || isFilter) &&
                    <React.Fragment>
                        <Dropdown theme={theme}
                                  dropdownType='multiple'
                                  optionsType='category'
                                  optionKey='code'
                                  optionLabelKey='name'
                                  value={data.category}
                                  valueKey='category'
                                  label='Category'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                        <Dropdown theme={theme}
                                  dropdownType='multiple'
                                  optionsType='type'
                                  optionKey='code'
                                  optionLabelKey='name'
                                  value={data.type}
                                  valueKey='type'
                                  label='Type'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                        {
                            (data.type === 'STNL' && data.category && !data.category.includes(',')) && getTenantSubcategorySTNL({data, handleChangeDropdown : handleParentDropdownChange, theme})
                        }
                        {
                            (data.type === 'MT' && data.category && !data.category.includes(',')) && getTenantSubcategoryMT({data, handleChangeDropdown : handleParentDropdownChange, theme})
                        }
                        <Dropdown theme={theme}
                                  dropdownType='multiple'
                                  optionsType='investor-market'
                                  value={data.market}
                                  valueKey='market'
                                  label='Market'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                        <DualRange theme={theme}
                                   minValue={data.price_min}
                                   maxValue={data.price_max}
                                   minName='price_min'
                                   maxName='price_max'
                                   valueType='integer'
                                   label='Price Range'
                                   handleParentChange={handleParentChange}
                        />
                        <DualRange theme={theme}
                                   minValue={data.cap_rate_min}
                                   maxValue={data.cap_rate_max}
                                   minName='cap_rate_min'
                                   maxName='cap_rate_max'
                                   valueType='percent'
                                   label='Cap Rate Range'
                                   handleParentChange={handleParentChange}
                        />
                        <SelectTeam theme={theme}
                                    value={data.strive_agent}
                                    valueKey='strive_agent'
                                    label='Agent'
                                    data={data}
                                    handleParentChange={handleParentDropdownChange}
                        />
                    </React.Fragment>
                }
                <Textarea theme={theme}
                          name='notes'
                          label='Notes'
                          value={data.notes}
                          maxWidth='100%'
                          handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Investor Company' : 'Add Investor Company'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='company_name'
                       label='Company Name'
                       value={data.company_name}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='company_address'
                       label='Company Address'
                       value={data.company_address}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='company_city'
                       label='City'
                       value={data.company_city}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.company_state}
                                  valueKey='company_state'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='company_zip'
                               label='Zip'
                               value={data.company_zip}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

InvestorForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    showGroupFilter: PropTypes.bool,
    ownerAgentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default InvestorForm;